import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import axios from "axios";
import dayjs from 'dayjs';
import { useEffect, useRef, useState } from "react";
import { MdArrowBack, MdCalendarMonth, MdClose } from "react-icons/md";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import { web_url } from "../../constant";
import { useWebSocket } from "../../websocket_context";


function TranslatorInbox({ t }) {
    const isXlOrLarger = useMediaQuery({ minWidth: 1270 });
    const [openError, setOpenError] = useState(false);
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false)

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setError(t('t93'));
        } else if (err.toLowerCase().includes('already seen')) {
            setError(t('t409'));
        } else if (err.toLowerCase().includes('found')) {
            setError(t('t214'));
        } else {
            setError(t('t94'));
        }
        setOpenError(true);
    };

    const handleCloseError = () => {
        localStorage.setItem("refresh", `${Date.now()}`);
        setOpenError(false);
    };

    const [searchInput, setSearchInput] = useState("");
    const navigate = useNavigate();

    const [mailsInbox, setMailsInbox] = useState([]);

    const [mailsRejected, setMailsRejected] = useState([]);

    const [date, setDate] = useState(null)

    const [showCloseIcon, setShowCloseIcon] = useState(null)
    const getLogDetails = () => {
        return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
    };
    const logDetails = getLogDetails();
    const messageIdsSet = useRef(new Set());
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    useEffect(() => {
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();
        if (!logDetails) return;

        const configToken = {
            headers: {
                'Authorization': `Bearer ${logDetails.token}`,
            },
        };

        const loadMessages = (studentList) => {
            setIsLoading(true);
            axios.post(`${web_url}/api/email-threads/participants/translators-moderate`, studentList, configToken).then((response) => {
                let allMessages = response.data.flatMap(
                    message => ({
                        ...message,
                        sentAt: formatDate(message.sentAt),
                        sentAtOriginal: formatDateNew(message.sentAt),
                        other: (message.participants.filter(email => email !== message.sender))[0]
                    }));

                allMessages.sort((a, b) => new Date(b.sentAt.replace(/-/g, "/")) - new Date(a.sentAt.replace(/-/g, "/")));
                const receivedMessages = allMessages.filter(msg => studentList.includes(msg.sender) && msg.status === "PENDING" && (!msg.allocatedTranslator || msg.allocatedTranslator === logDetails.email));
                const rejectedMessages = allMessages.filter(msg => studentList.includes(msg.sender) && msg.status === "REJECTED" && msg.moderationRecord.moderator === logDetails.email);

                setMailsInbox(receivedMessages);
                setMailsRejected(rejectedMessages);
                receivedMessages.forEach(msg => messageIdsSet.current.add(msg.messageId));
                rejectedMessages.forEach(msg => messageIdsSet.current.add(msg.messageId));
                setIsDataLoaded(true);
                setIsLoading(false);
            }).catch((err) => {
                setIsLoading(false);
                handleClickOpenError("error occured");
                console.log("Error1", err);
            });
        };

        const cachedStudents = JSON.parse(localStorage.getItem('students-assigned') || "[]");
        if (cachedStudents.length > 0) {
            loadMessages(cachedStudents);
        } else {
            setIsLoading(true);
            axios.get(`${web_url}/api/auth/translators/${logDetails.email}`, configToken).then((response) => {
                const schoolIds = response.data.schoolIds || [];
                if (schoolIds.length > 0) {
                    axios.get(`${web_url}/api/auth/schools`, configToken).then((resSchoolList) => {
                        const assignedSchoolNames = new Set(
                            resSchoolList.data
                                .filter(school => schoolIds.includes(school.id))
                                .map(school => (school.name || "").trim().toLowerCase())
                        );

                        axios.get(`${web_url}/api/auth/students`, configToken).then((resStudents) => {
                            const studentEmails = resStudents.data
                                .filter(student => student.school && assignedSchoolNames.has(student.school.trim().toLowerCase()))
                                .map(student => student.userEmail);

                            localStorage.setItem('students-assigned', JSON.stringify(studentEmails));
                            loadMessages(studentEmails);
                        }).catch(() => {
                            setIsLoading(false);
                        });
                    }).catch(() => {
                        setIsLoading(false);
                    });
                } else {
                    setIsLoading(false);
                }
            }).catch(() => {
                setIsLoading(false);
            });
        }
    }, [localStorage.getItem('refresh')])

    const { subscribeToTopic } = useWebSocket();

    useEffect(() => {
        if (!isDataLoaded) return;
        subscribeToTopic((data) => {
            const responseBody = data;
            let messages = responseBody.messages.map(message => ({
                ...message,
                threadId: responseBody.threadId,
                subject: (responseBody.subject) || " ",
                translatedSubject: (responseBody.translatedSubject) || " ",
                sentAt: formatDate(message.sentAt),
                sentAtOriginal: formatDateNew(message.sentAt),
                other: (responseBody.participants.filter(email => email !== message.sender))[0]
            }));
            const studentList = JSON.parse(localStorage.getItem('students-assigned'));
            messages.sort((a, b) => new Date(b.sentAt.replace(/-/g, "/")) - new Date(a.sentAt.replace(/-/g, "/")));

            const receivedMessages = messages.filter(msg => studentList.includes(msg.sender) && msg.isDraft === "FALSE" && msg.status === "PENDING" && msg.type === "PENPAL" && (!msg.allocatedTranslator || msg.allocatedTranslator === logDetails.email));
            const rejectedMessages = messages.filter(msg => studentList.includes(msg.sender) && msg.isDraft === "FALSE" && msg.type === "PENPAL" && msg.status === "REJECTED" && msg.moderationRecord.moderator === logDetails.email);

            const uniqueReceivedMessages = receivedMessages.filter(msg => {
                if (messageIdsSet.current.has(msg.messageId)) return false;
                messageIdsSet.current.add(msg.messageId);
                return true;
            });

            const uniqueRejectMessages = rejectedMessages.filter(msg => {
                if (messageIdsSet.current.has(msg.messageId)) return false;
                messageIdsSet.current.add(msg.messageId);
                return true;
            });

            setMailsInbox(prev => [...prev, ...uniqueReceivedMessages]);
            setMailsRejected(prev => [...prev, ...uniqueRejectMessages]);
        });

    }, [isDataLoaded]);

    useEffect(() => {
        if (date !== null) {
            setShowCloseIcon(true)
        } else {
            setShowCloseIcon(false)
        }
    }, [date])

    const filteredEmailsInbox = (mailsInbox ?? []).filter((mail) =>
        mail.sender?.toLowerCase().includes(searchInput.toLowerCase()) &&
        (!date || mail.sentAt?.startsWith(date)) // Check if date matches
    );

    const filteredEmailRejected = (mailsRejected ?? []).filter((mail) =>
        mail.other?.toLowerCase().includes(searchInput.toLowerCase()) &&
        (!date || mail.sentAt?.startsWith(date)) // Check if date matches
    );


    const [folderSelected, setFolderSelected] = useState(
        {
            inbox: true,
            rejected: false
        }
    )

    const formatDate = (timestamp) => {
        const dateObj = new Date(timestamp);

        // Convert to IST (UTC + 5:30)
        // const istOffset = 0;
        const istOffset = 5.5 * 60 * 60 * 1000; // 5.5 hours in milliseconds
        const istTime = new Date(dateObj.getTime() + istOffset);

        // Use .getFullYear(), .getMonth(), etc., instead of .getUTC*
        const year = istTime.getFullYear();
        const month = String(istTime.getMonth() + 1).padStart(2, "0"); // Ensure 2 digits
        const day = String(istTime.getDate()).padStart(2, "0"); // Ensure 2 digits
        const hours = String(istTime.getHours()).padStart(2, "0"); // Corrected
        const minutes = String(istTime.getMinutes()).padStart(2, "0"); // Corrected
        const sec = String(istTime.getSeconds()).padStart(2, "0"); // Corrected

        // console.log("old", timestamp);
        // console.log("new", `${year}-${month}-${day} ${hours}:${minutes}:${sec}`);

        return `${year}-${month}-${day} ${hours}:${minutes}:${sec}`;
    }

    const formatDateNew = (timestamp) => {
        return new Date(timestamp).toISOString(); // Ensures cross-browser compatibility
    };

    const handleAllocateTranslator = (mail, index) => {
        setIsLoading(true);
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();
        if (!mail.allocatedTranslator) {

            const configToken = {
                headers: {
                    'Authorization': `Bearer ${logDetails.token}`,
                },
            };

            axios.patch(`${web_url}/api/email-threads/${mail.threadId}/messages/${mail.messageId}/allocate/${logDetails.email}`, {}, configToken).then((r) => {
                setIsLoading(false);
                if (isXlOrLarger) {
                    localStorage.setItem('nowreading', index);
                    localStorage.setItem('mailreceived', JSON.stringify(mail));
                    localStorage.removeItem('maildraft');
                    localStorage.removeItem('mailsent');
                    localStorage.setItem('composenewclicked', 'false');
                    navigate('/desktop/translator/translatemail');
                } else {
                    localStorage.setItem('nowreading', index);
                    localStorage.setItem('mailreceived', JSON.stringify(mail));
                    localStorage.removeItem('maildraft');
                    localStorage.removeItem('mailsent');
                    localStorage.setItem('composenewclicked', 'false');
                    navigate('/mobile/translator/mailboxcheck');
                }
            }).catch((e) => {
                setIsLoading(false);
                if (e.response.data.message) {
                    if (e.response.data.message === "Message already has an allocated translator!") {
                        handleClickOpenError('already seen')
                    } else {
                        handleClickOpenError('error occured')
                    }
                } else {
                    handleClickOpenError('error occured')
                }
            })
        } else {
            setIsLoading(false);
            if (isXlOrLarger) {
                localStorage.setItem('nowreading', index);
                localStorage.setItem('mailreceived', JSON.stringify(mail));
                localStorage.removeItem('maildraft');
                localStorage.removeItem('mailsent');
                localStorage.setItem('composenewclicked', 'false');
                navigate('/desktop/translator/translatemail');
            } else {
                localStorage.setItem('nowreading', index);
                localStorage.setItem('mailreceived', JSON.stringify(mail));
                localStorage.removeItem('maildraft');
                localStorage.removeItem('mailsent');
                localStorage.setItem('composenewclicked', 'false');
                navigate('/mobile/translator/mailboxcheck');
            }
        }

    }

    return (
        <div className="mb-[100px] lg:mb-[130px] xl:mb-[20px]">
            <div className="pl-[30px] pr-[30px] xl:pr-[5px] md:items-center pt-[80px] md:pt-[120px] lg:pt-[140px] xl:pt-[20px] 2xl:pt-[25px]">
                <div className="xl:hidden flex items-center justify-start mt-[20px] lg:ml-[70px]">
                    <MdArrowBack
                        size={25}
                        className="md:hidden"
                        onClick={() => {
                            navigate('/mobile/translator/dashboard')
                        }}
                    />
                    <MdArrowBack
                        size={30}
                        className="hidden md:block xl:hidden"
                        onClick={() => {
                            navigate('/mobile/translator/dashboard')
                        }}
                    />
                    <p className="font-bold text-[20px] ml-[10px] md:text-[23px] lg:text-[25px] xl:text-[19px] 2xl:text-[25px]">
                        {t('t227')}
                    </p>
                </div>
                {
                    isLoading ?
                        <div className="items-center justify-center flex pt-[30px]">
                            <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                        </div>
                        :
                        <div className="md:mx-[30px] lg:mx-[100px] xl:mx-[60px]">
                            <div>
                                <input
                                    type="search"
                                    placeholder={t('t228')}
                                    onChange={(e) => setSearchInput(e.target.value)}
                                    value={searchInput}
                                    className="mt-4 p-2 md:p-3 lg:p-4 xl:p-1 2xl:p-2 border border-gray-300 rounded-md w-full text-black text-[15px] md:text-[18px]"
                                />
                            </div>
                            <div className="flex flex-wrap gap-[5px] w-full xl:gap-[0px] md:justify-center xl:justify-start">
                                <div className="w-full h-[40px] md:w-[250px] xl:w-[200px] md:h-[50px] xl:h-[40px] flex justify-center items-center text-[90px] md:text-[22px] xl:text-[16px] md:mr-[10px] min-w-[100px] rounded-md px-[2px] py-[0px] md:py-[10px] md:px-[20px] xl:py-[1px] xl:px-[10px]  border border-1 mt-[10px] border-gray-400 text-gray-700 bg-[#F1F6FB]">
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            value={date ? dayjs(date) : null}
                                            onChange={(date) => {
                                                if (date) {
                                                    const formattedDate = dayjs(date).format('YYYY-MM-DD');
                                                    setDate(formattedDate)
                                                }
                                            }}
                                            format="YYYY-MM-DD"
                                            slotProps={{
                                                textField: {
                                                    InputProps: {

                                                        style: {
                                                            border: 'none',
                                                            fontSize: window.innerWidth < 640 ? '14px' : window.innerWidth < 1024 ? '17px' : '17px',
                                                            color: '#1F2937',
                                                            fontFamily: 'Urbanist',
                                                            padding: '0 0 0 0'
                                                        },
                                                    },
                                                    placeholder: t('t229'),
                                                    fullWidth: true,
                                                    sx: {
                                                        '& .MuiOutlinedInput-root': {
                                                            border: 'none', // Remove outer border
                                                            boxShadow: 'none', // Remove shadow
                                                        },
                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                            border: 'none', // Remove outlined border
                                                        },
                                                        '&:hover .MuiOutlinedInput-notchedOutline': {
                                                            border: 'none', // Remove hover effect
                                                        },
                                                        '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                            border: 'none', // Remove focus effect
                                                        },
                                                    },
                                                },
                                            }}
                                        />
                                    </LocalizationProvider>
                                    {
                                        !showCloseIcon && <MdCalendarMonth size="30px" className="xl:hidden text-gray-500 ml-[5px]" />
                                    }
                                    {
                                        showCloseIcon && <MdClose onClick={() => setDate(null)} size="30px" className="2xl:block text-gray-500 ml-[5px]" />
                                    }
                                </div>
                                <button className={`text-[15px] md:text-[20px] xl:text-[16px] md:mr-[10px] rounded-md px-[45px] py-[5px] md:py-[10px] md:px-[40px] xl:py-[1px] xl:px-[10px] border border-1 mt-[10px] border-gray-400 text-gray-700 ${folderSelected.inbox ? 'bg-[#FFEBA9] text-[#816D2B]' : 'bg-[#F1F6FB] text-[#8189B0]'}`} onClick={() => { localStorage.setItem("folder", 0); setFolderSelected({ inbox: true, rejected: false }) }} >{t('t420')}</button>
                                <button className={`text-[15px] md:text-[20px] xl:text-[16px] md:mr-[10px] rounded-md px-[35px] py-[5px] md:py-[10px] md:px-[40px] xl:py-[1px] xl:px-[10px] border border-1 mt-[10px] border-gray-400 text-gray-700 ${folderSelected.rejected ? 'bg-[#FFEBA9] text-[#816D2B]' : 'bg-[#F1F6FB] text-[#8189B0]'}`} onClick={() => { localStorage.setItem("folder", 1); setFolderSelected({ inbox: false, rejected: true }) }}>{t('t242')}</button>
                            </div>

                            <div className="xl:hidden">
                                {
                                    folderSelected.inbox &&
                                    <div className="mt-6">
                                        {filteredEmailsInbox
                                            .slice()
                                            .sort((a, b) => new Date(b.sentAtOriginal).getTime() - new Date(a.sentAtOriginal).getTime())
                                            .map((mail, index) => (
                                                <div key={index} className="flex flex-col bg-[#F1F6FB] mb-[10px] md:mb-[15px] p-[10px] rounded-md"
                                                    onClick={() => {
                                                        handleAllocateTranslator(mail, index);
                                                    }}
                                                >
                                                    <div className="flex justify-between">
                                                        <p className="text-black text-[12px] md:text-[18px] lg:text-[20px] xl:text-[15px] 2xl:text-[17px] font-bold">{mail.sender}</p>
                                                        <p className="text-black text-[12px] md:text-[17px] lg:text-[19px] xl:text-[15px] 2xl:text-[17px]">{mail.sentAt.slice(0, -3)}</p>
                                                    </div>
                                                    <div className="md:hidden text-black text-[13px] md:text-[17px]">
                                                        <p>{mail.subject.trim() !== "" ?
                                                            (mail.subject.length > 30
                                                                ? `${mail.subject.slice(0, 30)}...`
                                                                : mail.subject) : "(No subject)"}</p>
                                                    </div>
                                                    <div className="hidden md:block lg:hidden text-black text-[13px] md:text-[17px] lg:text-[19px]">
                                                        <p>{mail.subject.trim() !== "" ?
                                                            (mail.subject.length > 60
                                                                ? `${mail.subject.slice(0, 60)}...`
                                                                : mail.subject) : "(No subject)"}</p>
                                                    </div>
                                                    <div className="hidden lg:block xl:hidden text-black text-[13px] md:text-[17px]">
                                                        <p>{mail.subject.trim() !== "" ?
                                                            (mail.subject.length > 70
                                                                ? `${mail.subject.slice(0, 70)}...`
                                                                : mail.subject) : "(No subject)"}</p>
                                                    </div>
                                                    <div className="hidden xl:block 2xl:hidden text-black text-[13px] md:text-[17px] xl:text-[15px]">
                                                        <p>{mail.subject.trim() !== "" ?
                                                            (mail.subject.length > 100
                                                                ? `${mail.subject.slice(0, 100)}...`
                                                                : mail.subject) : "(No subject)"}</p>
                                                    </div>
                                                    <div className="hidden 2xl:block text-black text-[13px] md:text-[17px] xl:text-[15px]">
                                                        <p>{mail.subject.trim() !== "" ?
                                                            (mail.subject.length > 140
                                                                ? `${mail.subject.slice(0, 140)}...`
                                                                : mail.subject) : "(No subject)"}</p>
                                                    </div>
                                                </div>
                                            ))}

                                    </div>
                                }
                                {
                                    folderSelected.rejected &&
                                    <div className="mt-6">
                                        {filteredEmailRejected
                                            .slice()
                                            .sort((a, b) => new Date(b.sentAtOriginal).getTime() - new Date(a.sentAtOriginal).getTime())
                                            .map((mail, index) => (
                                                <div key={index} className="flex flex-col bg-[#F1F6FB] mb-[10px] md:mb-[15px] p-[10px] rounded-md"
                                                    onClick={() => {
                                                        localStorage.setItem('nowreading', index);
                                                        localStorage.setItem('mailreceived', JSON.stringify(mail));
                                                        localStorage.removeItem('maildraft');
                                                        localStorage.removeItem('mailsent');
                                                        localStorage.setItem('composenewclicked', 'false');
                                                        navigate('/mobile/translator/mailboxcheck');
                                                    }}
                                                >
                                                    <div className="flex justify-between">
                                                        <p className="text-black text-[12px] md:text-[18px] lg:text-[20px] xl:text-[15px] 2xl:text-[17px] font-bold">{mail.sender}</p>
                                                        <p className="text-black text-[12px] md:text-[17px] lg:text-[19px] xl:text-[15px] 2xl:text-[17px]">{mail.sentAt.slice(0, -3)}</p>
                                                    </div>
                                                    <div className="md:hidden text-black text-[13px] md:text-[17px]">
                                                        <p>{mail.subject.trim() !== "" ?
                                                            (mail.subject.length > 30
                                                                ? `${mail.subject.slice(0, 30)}...`
                                                                : mail.subject) : "(No subject)"}</p>
                                                    </div>
                                                    <div className="hidden md:block lg:hidden text-black text-[13px] md:text-[17px] lg:text-[19px]">
                                                        <p>{mail.subject.trim() !== "" ?
                                                            (mail.subject.length > 60
                                                                ? `${mail.subject.slice(0, 60)}...`
                                                                : mail.subject) : "(No subject)"}</p>
                                                    </div>
                                                    <div className="hidden lg:block xl:hidden text-black text-[13px] md:text-[17px]">
                                                        <p>{mail.subject.trim() !== "" ?
                                                            (mail.subject.length > 70
                                                                ? `${mail.subject.slice(0, 70)}...`
                                                                : mail.subject) : "(No subject)"}</p>
                                                    </div>
                                                    <div className="hidden xl:block 2xl:hidden text-black text-[13px] md:text-[17px] xl:text-[15px]">
                                                        <p>{mail.subject.trim() !== "" ?
                                                            (mail.subject.length > 100
                                                                ? `${mail.subject.slice(0, 100)}...`
                                                                : mail.subject) : "(No subject)"}</p>
                                                    </div>
                                                    <div className="hidden 2xl:block text-black text-[13px] md:text-[17px] xl:text-[15px]">
                                                        <p>{mail.subject.trim() !== "" ?
                                                            (mail.subject.length > 140
                                                                ? `${mail.subject.slice(0, 140)}...`
                                                                : mail.subject) : "(No subject)"}</p>
                                                    </div>
                                                </div>
                                            ))}

                                    </div>
                                }

                            </div>
                            <div className="hidden xl:block">
                                {
                                    folderSelected.inbox &&
                                    <div className="mt-6">
                                        {filteredEmailsInbox
                                            .slice()
                                            .sort((a, b) => new Date(b.sentAtOriginal).getTime() - new Date(a.sentAtOriginal).getTime())
                                            .map((mail, index) => (
                                                <div key={index} className="cursor-pointer flex flex-col bg-[#F1F6FB] mb-[10px] md:mb-[15px] p-[10px] rounded-md"
                                                    onClick={() => {
                                                        handleAllocateTranslator(mail, index);
                                                    }}
                                                >
                                                    <div className="flex justify-between">
                                                        <p className="text-black text-[12px] md:text-[18px] lg:text-[20px] xl:text-[15px] 2xl:text-[17px] font-bold">{mail.sender}</p>
                                                        <p className="text-black text-[12px] md:text-[17px] lg:text-[19px] xl:text-[15px] 2xl:text-[17px]">{mail.sentAt.slice(0, -3)}</p>
                                                    </div>
                                                    <div className="md:hidden text-black text-[13px] md:text-[17px]">
                                                        <p>{mail.subject.trim() !== "" ?
                                                            (mail.subject.length > 30
                                                                ? `${mail.subject.slice(0, 30)}...`
                                                                : mail.subject) : "(No subject)"}</p>
                                                    </div>
                                                    <div className="hidden md:block lg:hidden text-black text-[13px] md:text-[17px] lg:text-[19px]">
                                                        <p>{mail.subject.trim() !== "" ?
                                                            (mail.subject.length > 60
                                                                ? `${mail.subject.slice(0, 60)}...`
                                                                : mail.subject) : "(No subject)"}</p>
                                                    </div>
                                                    <div className="hidden lg:block xl:hidden text-black text-[13px] md:text-[17px]">
                                                        <p>{mail.subject.trim() !== "" ?
                                                            (mail.subject.length > 70
                                                                ? `${mail.subject.slice(0, 70)}...`
                                                                : mail.subject) : "(No subject)"}</p>
                                                    </div>
                                                    <div className="hidden xl:block 2xl:hidden text-black text-[13px] md:text-[17px] xl:text-[15px]">
                                                        <p>{mail.subject.trim() !== "" ?
                                                            (mail.subject.length > 100
                                                                ? `${mail.subject.slice(0, 100)}...`
                                                                : mail.subject) : "(No subject)"}</p>
                                                    </div>
                                                    <div className="hidden 2xl:block text-black text-[13px] md:text-[17px] xl:text-[15px]">
                                                        <p>{mail.subject.trim() !== "" ?
                                                            (mail.subject.length > 140
                                                                ? `${mail.subject.slice(0, 140)}...`
                                                                : mail.subject) : "(No subject)"}</p>
                                                    </div>
                                                </div>
                                            ))}

                                    </div>
                                }
                                {
                                    folderSelected.rejected &&
                                    <div className="mt-6">
                                        {filteredEmailRejected
                                            .slice()
                                            .sort((a, b) => new Date(b.sentAtOriginal).getTime() - new Date(a.sentAtOriginal).getTime())
                                            .map((mail, index) => (
                                                <div key={index} className="cursor-pointer flex flex-col bg-[#F1F6FB] mb-[10px] md:mb-[15px] p-[10px] rounded-md"
                                                    onClick={() => {
                                                        localStorage.setItem('nowreading', index);
                                                        localStorage.setItem('mailreceived', JSON.stringify(mail));
                                                        localStorage.removeItem('maildraft');
                                                        localStorage.removeItem('mailsent');
                                                        localStorage.setItem('composenewclicked', 'false');
                                                        navigate('/desktop/translator/translatemail');
                                                    }}
                                                >
                                                    <div className="flex justify-between">
                                                        <p className="text-black text-[12px] md:text-[18px] lg:text-[20px] xl:text-[15px] 2xl:text-[17px] font-bold">{mail.sender}</p>
                                                        <p className="text-black text-[12px] md:text-[17px] lg:text-[19px] xl:text-[15px] 2xl:text-[17px]">{mail.sentAt.slice(0, -3)}</p>
                                                    </div>
                                                    <div className="md:hidden text-black text-[13px] md:text-[17px]">
                                                        <p>{mail.subject.trim() !== "" ?
                                                            (mail.subject.length > 30
                                                                ? `${mail.subject.slice(0, 30)}...`
                                                                : mail.subject) : "(No subject)"}</p>
                                                    </div>
                                                    <div className="hidden md:block lg:hidden text-black text-[13px] md:text-[17px] lg:text-[19px]">
                                                        <p>{mail.subject.trim() !== "" ?
                                                            (mail.subject.length > 60
                                                                ? `${mail.subject.slice(0, 60)}...`
                                                                : mail.subject) : "(No subject)"}</p>
                                                    </div>
                                                    <div className="hidden lg:block xl:hidden text-black text-[13px] md:text-[17px]">
                                                        <p>{mail.subject.trim() !== "" ?
                                                            (mail.subject.length > 70
                                                                ? `${mail.subject.slice(0, 70)}...`
                                                                : mail.subject) : "(No subject)"}</p>
                                                    </div>
                                                    <div className="hidden xl:block 2xl:hidden text-black text-[13px] md:text-[17px] xl:text-[15px]">
                                                        <p>{mail.subject.trim() !== "" ?
                                                            (mail.subject.length > 100
                                                                ? `${mail.subject.slice(0, 100)}...`
                                                                : mail.subject) : "(No subject)"}</p>
                                                    </div>
                                                    <div className="hidden 2xl:block text-black text-[13px] md:text-[17px] xl:text-[15px]">
                                                        <p>{mail.subject.trim() !== "" ?
                                                            (mail.subject.length > 140
                                                                ? `${mail.subject.slice(0, 140)}...`
                                                                : mail.subject) : "(No subject)"}</p>
                                                    </div>
                                                </div>
                                            ))}

                                    </div>
                                }

                            </div>
                        </div>
                }
            </div>
            <Dialog
                open={openError}
                onClose={handleCloseError}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    {t('t95')}
                </DialogTitle>
                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {error}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleCloseError}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default TranslatorInbox;